import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles({
  menuItemClass: {
    fontSize: "12px",
  },
});
